namespace $.$$ {
	$mol_style_define($shm_hitalama_benchmarks_page_metrics, {
		Col_head: {
			padding: { top: '0.25rem', bottom: '0.25rem', left: '0.5rem', right: '0.5rem' },
			'[indexed]': { true: { whiteSpace: 'pre-line', width: '11rem', maxWidth: '11rem' } },
		},
		Cell_text: { padding: { top: '0.25rem', bottom: '0.25rem', left: '0.5rem', right: '0.5rem' } },
		Cell_number: { padding: { top: '0.25rem', bottom: '0.25rem', left: '0.5rem', right: '0.5rem' } },
		// The icon already has button padding; do not add cell padding around it.
		Details: { padding: 0 },
		Delete: { padding: 0 },
	})
}
